/**
 * @typedef {Object} LatLng
 * @property {number} lat
 * @property {number} lng
 */

export default {
    /**
     * 
     * @returns {Promise<LatLng>}
     */
    getCurrentLocation: function () {
        return new Promise((resolve, reject) => {
            navigator.geolocation.getCurrentPosition((data) => {
                let lat = data.coords.latitude;
                let lng = data.coords.longitude;
                resolve({ lat: lat, lng: lng });
            }, (error) => {
                reject(error);
            });
        });
    },
};
